import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useLoginQuery } from "../../services/authorization/api";
import useRoleAuthentication from "./useRoleAuthentication";

function useUnauthorizedRedirect() {
    const loginQuery = useLoginQuery();
    const isLoadingLoginInfo = loginQuery.isLoading || loginQuery.isFetching || !loginQuery.data?.name; // Check name make sure we have login data
    
    const location = useLocation();
    const navigate = useNavigate();
    const auth = useRoleAuthentication();
  
    useEffect(() => {
        if (location?.pathname === "/unauthorized") { return; }
        if (isLoadingLoginInfo || auth.isAdmin) { return; }
        
        navigate("/unauthorized");
    }, [location?.pathname, isLoadingLoginInfo, auth.isAdmin, navigate]);
}

export default useUnauthorizedRedirect;
